import 'angular-uuid';
import 'ng-currency';
import ngMessages from 'angular-messages';
import uibDatepicker from 'angular-ui-bootstrap/src/datepicker';
import uibDatepickerPopup from 'angular-ui-bootstrap/src/datepickerPopup';
import focusIf from 'ng-focus-if';
import uiFileUpload from '@fino/ng1-file-upload';
import uiLoadingIndicator from '@fino/ng1-loading-indicator';
import { FormControlTypes } from './formControl.constants';
import { FormControlDirective } from './formControl.directive';
import { FormControlProvider } from './formControl.provider';
import { FormControlService } from './formControl.service';
import { FocusDirective } from './focus.directive';
import { StaticInclude } from './staticInclude.directive';

// Templates
import checkboxTpl from './templates/formControl.checkbox.html';
import dateTpl from './templates/formControl.date.html';
import currencyTpl from './templates/formControl.currency.html';
import defaultTpl from './templates/formControl.default.html';
import ibanTpl from './templates/formControl.iban.html';
import multiSelectTpl from './templates/formControl.multiSelect.html';
import numberTpl from './templates/formControl.number.html';
import radioTpl from './templates/formControl.radio.html';
import selectTpl from './templates/formControl.select.html';
import suggestTpl from './templates/formControl.suggest.html';
import textareaTpl from './templates/formControl.textarea.html';
import textlistTpl from './templates/formControl.textlist.html';
import toggleTpl from './templates/formControl.toggle.html';
import uploadTpl from './templates/formControl.upload.html';

export default angular
  .module('ng1-form-control', [
    'angular-uuid',
    'ng-currency',
    uibDatepicker,
    uibDatepickerPopup,
    ngMessages,
    focusIf,
    uiFileUpload,
    uiLoadingIndicator
  ])
  .run(($templateCache) => {
    'ngInject';
    $templateCache.put('templates/formControl.checkbox.html', checkboxTpl);
    $templateCache.put('templates/formControl.date.html', dateTpl);
    $templateCache.put('templates/formControl.currency.html', currencyTpl);
    $templateCache.put('templates/formControl.default.html', defaultTpl);
    $templateCache.put('templates/formControl.iban.html', ibanTpl);
    $templateCache.put('templates/formControl.multiSelect.html', multiSelectTpl);
    $templateCache.put('templates/formControl.number.html', numberTpl);
    $templateCache.put('templates/formControl.radio.html', radioTpl);
    $templateCache.put('templates/formControl.select.html', selectTpl);
    $templateCache.put('templates/formControl.suggest.html', suggestTpl);
    $templateCache.put('templates/formControl.textarea.html', textareaTpl);
    $templateCache.put('templates/formControl.textlist.html', textlistTpl);
    $templateCache.put('templates/formControl.textlist.html', textlistTpl);
    $templateCache.put('templates/formControl.toggle.html', toggleTpl);
    $templateCache.put('templates/formControl.upload.html', uploadTpl);
  })
  .constant('fdFormControlTypes', FormControlTypes)
  .directive('fdFormControl', FormControlDirective)
  .provider('formControl', FormControlProvider)
  .service('formControlService', FormControlService)
  .directive('setFocus', FocusDirective)
  .directive('staticInclude', StaticInclude)
  .name;
